import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { isFunction, isNumber } from "lodash";
import { useEffect, useState } from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

function Pagination({ onChangeCurrentPage, onChangeTotalPages, totalCount, itemsPerPage }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [displayPageNumber, setDisplayPageNumbers] = useState([]);

    useEffect(() => {
        //console.log("🚀 ~ Pagination ~ totalCount:", totalCount);
        calculateTotalPages();
    }, [totalCount]);

    useEffect(() => {
        console.log("[useEffect itemsPerPage][itemsPerPage] => ", itemsPerPage);
        console.log("[useEffect itemsPerPage][setCurrentPage] => ", 1);
        setCurrentPage(1);
        calculateTotalPages();
    }, [itemsPerPage]);

    useEffect(() => {
        console.log("[useEffect][currentPage] => ", currentPage);
        calculateDisplayPageNumbers();
        console.log("Pagination current page ==> ", currentPage);
        if (onChangeCurrentPage && isFunction(onChangeCurrentPage)) {
            onChangeCurrentPage(currentPage);
        }
    }, [currentPage]);

    useEffect(() => {
        calculateDisplayPageNumbers();
    }, [totalPages]);

    /**
     * 데이터 카운트따라 총 페이지수 계산하는 함수
     */
    const calculateTotalPages = () => {
        //console.log("calculateTotalPages START ==> ");
        //console.log("TOTAL COUNT => ", totalCount);
        //console.log("ITEMS PER PAGE => ", itemsPerPage);
        if (totalCount && isNumber(totalCount)) {
            const totalPages = Math.ceil(parseFloat(totalCount / itemsPerPage));

            //console.log("🚀 ~ calculateTotalPages ~ totalPages:", totalPages);
            setTotalPages(totalPages);
            if (onChangeTotalPages && isFunction(onChangeTotalPages)) {
                onChangeTotalPages(totalPages);
            }
        }
    };

    /**
     * 페이지 인덱스 줄이기
     */
    const navigatePrePage = () => {
        if (currentPage > 1) {
            const newCurrentPage = currentPage - 1;
            console.log("NEW CURRENT PAGE ==> ", newCurrentPage);
            setCurrentPage(newCurrentPage);
        }
    };

    /**
     * 페이지 인덱스 올리기
     */
    const navigateNextPage = () => {
        if (currentPage < totalPages) {
            const newCurrentPage = currentPage + 1;
            console.log("[navigateNextPage][setCurrentPage] ==> ", newCurrentPage);
            setCurrentPage(newCurrentPage);
        }
    };

    /**
     * 페이지번호 클릭 이벤트 핸들
     */
    const handleOnPageChange = (pageIndex) => {
        // //console.log("🚀 ~ handleOnPageChange ~ pageIndex:", pageIndex);
        console.log("[handleOnPageChange][setCurrentPage] => ", pageIndex);
        setCurrentPage(pageIndex);
    };

    /**
     * 페이징 페이즈 리스트 계산하는 함수
     */
    const calculateDisplayPageNumbers = () => {
        //console.log("CURRENT PAGE => ", currentPage);
        //console.log("TOTAL PAGES => ", totalPages);

        let minIndex = 0;
        let maxIndex = 0;

        if (totalPages > 5) {
            if (totalPages - currentPage >= 4) {
                minIndex = currentPage;
                maxIndex = currentPage + 4;
            } else {
                minIndex = totalPages - 4;
                maxIndex = totalPages;
            }
        } else {
            minIndex = 1;
            maxIndex = totalPages;
        }

        //console.log("MIN INDEX => ", minIndex);
        //console.log("MAX INDEX => ", maxIndex);

        let disPageNumbers = [];
        for (let index = minIndex; index <= maxIndex; index++) {
            disPageNumbers.push(index);
        }
        setDisplayPageNumbers(disPageNumbers);
    };

    /**
     *
     * @returns 몇번째 데이터부터 보여 주는 인덱스
     */
    const calculateShowingStartIndex = () => {
        //console.log("🚀 ~ calcualateShowingStartIndex ~ currentPage:", currentPage);
        //console.log("ITEMS PER PAGE => ", itemsPerPage);
        return (currentPage - 1) * itemsPerPage + 1;
    };

    /**
     *
     * @returns 몇번째까지 데이터 보여 주는 인덱스
     */
    const calculateShowingEndIndex = () => {
        //console.log("🚀 ~ calcualateShowingEndIndex ~ currentPage:", currentPage);
        //console.log("ITEMS PER PAGE => ", itemsPerPage);
        const endIdx = currentPage * itemsPerPage;

        if (endIdx > totalCount) {
            return totalCount;
        } else {
            return endIdx;
        }
    };

    return (
        <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
            <div className="flex flex-1 justify-between sm:hidden">
                <a
                    href="#"
                    className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    이전
                </a>
                <a
                    href="#"
                    className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    다음
                </a>
            </div>
            <div className="hidden sm:grid sm:flex-1 sm:grid-cols-[auto_1fr_auto] sm:items-center">
                <div className="justify-self-start">
                    <p className="text-sm text-gray-700">
                        <span className="font-semibold">{totalCount}</span> 결과중{" "}
                        <span className="font-semibold">{calculateShowingStartIndex()}</span>에서{" "}
                        <span className="font-semibold">{calculateShowingEndIndex()}</span>까지 표시중
                    </p>
                </div>
                <div className="justify-self-center">
                    <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                        <a
                            className={classNames(
                                "relative inline-flex items-center rounded-l-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0",
                                currentPage === 1 ? "text-gray-400 cursor-default" : "text-gray-900 cursor-pointer"
                            )}
                            onClick={navigatePrePage}
                        >
                            <span className="sr-only">이전</span>
                            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                        </a>
                        {displayPageNumber &&
                            displayPageNumber.length > 0 &&
                            displayPageNumber.map((pageNumber, index) => {
                                return (
                                    <a
                                        key={index}
                                        href="#"
                                        aria-current="page"
                                        className={classNames(
                                            "relative inline-flex items-center px-4 py-2 text-sm font-semibold focus:z-20 ",
                                            currentPage === pageNumber
                                                ? "z-10 text-white bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0 "
                                        )}
                                        onClick={() => handleOnPageChange(pageNumber)}
                                    >
                                        {pageNumber}
                                    </a>
                                );
                            })}
                        <a
                            className={classNames(
                                "relative inline-flex items-center rounded-r-md px-2 py-2  ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0",
                                currentPage === displayPageNumber[displayPageNumber.length - 1]
                                    ? "text-gray-400 cursor-default"
                                    : "text-gray-900 cursor-pointer"
                            )}
                            onClick={navigateNextPage}
                        >
                            <span className="sr-only">다음</span>
                            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                        </a>
                    </nav>
                </div>
                <div />
            </div>
        </div>
    );
}

export default Pagination;
